import { render, staticRenderFns } from "./TabMensalista.vue?vue&type=template&id=7072e0a7&"
import script from "./TabMensalista.vue?vue&type=script&lang=js&"
export * from "./TabMensalista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports